// extracted by mini-css-extract-plugin
export default {"certificate":"Certif_certificate__bGSBz","logo":"Certif_logo__wlQEj","button":"Certif_button__2tM6N"};